<template>
  <div
    :class="['option-container', 'space-between', displayLayout, layoutVersion]"
  >
    <div class="item-label">
      <MBIcon :name="iconName" :size="iconSize" color="#D9D9D9" />
      <span class="desc">{{ labelName }}</span>
    </div>
    <div class="item-selected">
      <input
        readonly
        type="text"
        class="item-wrapper space-between"
        :class="showList ? 'focus arrow-up' : 'arrow-down'"
        :value="selectedName"
        @click="onClick"
        @blur="onBlur"
      />
      <van-icon
        name="play"
        :class="['arrow', showList ? 'up' : 'down']"
        :size="10"
        @click="onClick"
      />
      <ul
        class="dropdown-list-wrapper"
        v-show="showList"
        :class="showList ? 'focus' : ''"
      >
        <li
          class="dropdown-list-item flex-start"
          :class="key === selectdKey ? 'chosen' : ''"
          v-for="[key, item] in Object.entries(dataSource)"
          :key="key"
          @mousedown="onSelected(key)"
        >
          <img
            v-if="!!item.icon"
            :src="require(`@/assets/images/common/flag-icon/${item.icon}`)"
            :alt="`flag`"
          />
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import MBIcon from '@/components/MBIcon'

  export default {
    name: 'dropdown-list',
    components: {
      MBIcon,
    },
    props: {
      dataSource: {
        type: Object,
        default: () => {},
      },
      labelName: String,
      currentOption: String,
      iconName: String,
      iconSize: {
        type: [Number, String],
        default: 16,
      },
    },
    data() {
      return {
        showList: false,
        selectdKey: this.currentOption,
      }
    },
    computed: {
      ...mapState(['layoutVersion']),
      ...mapGetters(['displayLayout']),
      selectedName() {
        return this.dataSource[this.selectdKey]?.value
      },
    },
    watch: {
      currentOption(val) {
        this.selectdKey = val
      },
      showList(val) {
        if (!val) return
        const target = document.querySelector('.dropdown-list-item.chosen')
        this.$nextTick(() => {
          target && target.scrollIntoView({ block: 'center' })
        })
      },
    },
    methods: {
      onClick() {
        this.showList = !this.showList
      },
      onBlur() {
        this.showList = false
      },
      onSelected(key) {
        // 注意务必在 onmousedown 上绑定该方法，事件触发顺序：mousedown -> blur -> click
        this.$emit('selected', key)
        this.showList = false
      },
    },
  }
</script>

<style lang="scss" scoped>
  .option-container.desktop-layout {
    font-family: 'Roboto';
    margin-bottom: 20px;
    .item-label {
      .desc {
        margin-left: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: rgba(255, 255, 255, 0.6);
      }
    }
    .item-selected {
      position: relative;

      .arrow {
        position: absolute;
        top: 50%;
        right: 20px;
        translate: 0 -5px;
        color: rgba(255, 255, 255, 0.5);
        &.up {
          transform: rotate(-90deg);
        }
        &.down {
          transform: rotate(90deg);
        }
        &:hover {
          cursor: pointer;
        }
      }
    }
    .item-wrapper {
      width: 286px;
      height: 50px;
      padding: 15px 20px 15px 24px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      box-sizing: border-box;
      background: rgba(255, 255, 255, 0.05);
      border-radius: 8px;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
      color: rgba(255, 255, 255, 0.9);
      &:hover {
        cursor: pointer;
      }
    }

    .focus {
      border: 1px solid rgba(249, 96, 0, 1);
      background: #352d2d;
    }

    .dropdown-list-wrapper {
      width: 286px;
      max-height: 278px;
      box-sizing: border-box;
      position: absolute;
      top: 60px;
      border-radius: 8px;
      z-index: 1;
      scrollbar-color: rgba(255, 255, 255, 0.2);
      scrollbar-width: 6px;
      overflow-y: scroll;
      /* 火狐浏览器不支持 overlay */
      overflow-y: overlay;
      @supports not (overflow-y: overlay) {
        overflow-y: scroll;
      }
      @include scrollingBar(
        $barWidth: 6px,
        $barHeight: 8px,
        $scrollbarBg: rgba(255, 255, 255, 0.2)
      );
      &::-webkit-scrollbar {
        position: absolute;
        right: 0;
      }
      .dropdown-list-item {
        padding: 14px 24px;
        img {
          width: 32px;
          height: 20.62px;
          object-fit: contain;
          margin-right: 10px;
        }
        span {
          font-weight: 500;
          font-size: 18px;
          line-height: 21px;
          color: #fff;
        }
        &:hover {
          cursor: pointer;
          background-color: #f96000;
        }
      }
    }
  }
</style>
